
export const DEFAULT_MAX_FORCE = 1023;
